import React, { useState } from "react";
import { cachedPublicLogoSrc, DEFAULT_PUBLIC_LOGO } from "../contexts/BrandingContext";
import { resolveCompanyMediaUrl } from "../lib/whiteLabeling";

function bootLogoSrc() {
  try {
    if (typeof window !== "undefined" && window.location.pathname.startsWith("/admin")) {
      const raw = localStorage.getItem("company_admin_company");
      const company = raw ? JSON.parse(raw) : null;
      const clinicLogo = company?.white_labeling?.clinic_logo;
      if (clinicLogo) {
        const url = resolveCompanyMediaUrl(clinicLogo);
        if (url) return url;
      }
    }
  } catch {
    /* ignore */
  }
  return cachedPublicLogoSrc() || DEFAULT_PUBLIC_LOGO;
}

/** Full-viewport boot UI while the JS bundle / first route chunk loads. */
export function AppBootScreen({ label = "Loading…" }) {
  const [logoSrc, setLogoSrc] = useState(() => bootLogoSrc());

  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center gap-3 bg-background text-muted-foreground"
      role="status"
      aria-live="polite"
      data-testid="app-boot-screen"
    >
      <img
        src={logoSrc}
        alt=""
        className="h-36 w-36 object-contain"
        onError={() => {
          // Cached branding / clinic logos can 404 after uploads rotate — fall back to bundled icon.
          if (logoSrc !== DEFAULT_PUBLIC_LOGO) setLogoSrc(DEFAULT_PUBLIC_LOGO);
        }}
      />
      <div className="h-8 w-8 animate-spin rounded-full border-[3px] border-muted border-t-primary" />
      <p className="text-sm font-semibold">{label}</p>
    </div>
  );
}

/** Spinner for the admin content pane so the sidebar can stay visible. */
export function LayoutContentFallback({ label = "Loading…" }) {
  return (
    <div
      className="flex flex-1 min-h-[40vh] items-center justify-center"
      role="status"
      aria-live="polite"
      data-testid="layout-content-fallback"
    >
      <div className="flex flex-col items-center gap-3 text-muted-foreground">
        <div className="h-8 w-8 animate-spin rounded-full border-[3px] border-muted border-t-primary" />
        <p className="text-sm font-semibold">{label}</p>
      </div>
    </div>
  );
}

export default AppBootScreen;
